import { Navigate, useLocation } from "react-router";
import { useAuth } from "../contexts/AuthContext";
import { usePermissions } from "../contexts/PermissionContext";
import { Loading } from "./Loading";
import { Box, Typography } from "@mui/material";
import { AppRoutes } from "../constants/appRoutes";

const AccessDenied = () => (
  <Box sx={{ p: 4, textAlign: "center" }}>
    <Typography variant="h5" color="error" gutterBottom>
      Access Denied
    </Typography>
    <Typography color="text.secondary">
      You do not have permission to view this page.
    </Typography>
  </Box>
);

export const ProtectedRoute = ({ children, permission, logic = "AND" }) => {
  const { user, loading } = useAuth();
  const { hasPermission } = usePermissions();
  const location = useLocation();

  if (loading) {
    return <Loading message="Checking authentication..." />;
  }

  if (!user) {
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} replace />;
  }

  if (permission && !hasPermission(permission, { logic })) {
    return <AccessDenied />;
  }

  return children;
};
